import { render } from "./App.vue?vue&type=template&id=93f02b78"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=93f02b78&lang=css"

import exportComponent from "/vercel/path0/Web_Apps/Dorm_Review/WebUI/UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__